import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingIndicator = () => (
  <CircularProgress />
);

export default LoadingIndicator;